import { createContext, Fragment, useState } from 'react'

import { Visibility } from 'globalTypes'
import SlidingPane from 'react-sliding-pane'

import AssociateToCollections from './AssociateToCollections'

interface Content {
  id: string
  visibility: Visibility
}

interface ContextProps {
  content?: Content
  setContent: (content: Content) => void
}

export const Context = createContext<ContextProps>({
  content: undefined,
  setContent: () => {},
})
Context.displayName = 'AssociationContext'

export const Provider = Context.Provider
export const Consumer = Context.Consumer

interface Props {
  children: React.ReactNode | React.ReactNode[]
}

const AssociationContext = ({ children }: Props) => {
  const [content, setContent] = useState<Content | undefined>(undefined)

  const value = {
    content,
    setContent,
  }

  const isOpen = typeof content !== 'undefined'

  return (
    <Fragment>
      <Provider value={value}>{children}</Provider>
      {isOpen && (
        <SlidingPane
          from="bottom"
          hideHeader
          isOpen={isOpen}
          onRequestClose={() => setContent(undefined)}
          overlayClassName="z-30 w-screen"
          shouldCloseOnEsc
          width="100%"
        >
          <AssociateToCollections id={content.id} />
        </SlidingPane>
      )}
    </Fragment>
  )
}

export default AssociationContext
